// BCM-898 · Goods Receipt Dashboard — View Info icons (slides 36, 37).
//
// Per the mockup both icons are plain blue outline icons (no bordered box):
//   * eye      -> View Batch Info (reuses ViewBatchesScreen -> QuickView). Opened
//                 from here it hides the "View Digitalized Information" / "View
//                 Goods Receipt and Consumption Validation" buttons and swaps
//                 Plant ID + Storage Location ID for PO Number (isFromGoodsReceipt).
//   * document -> View Digitalized Information (ViewDigitalizedInfo), which carries
//                 Sync Inventory / Sync PO / Resubmit Document.
// Gated on featuresAccess.viewFGBatch / featuresAccess.viewFGConsumption.
import React from "react";
import { Box, IconButton } from "@material-ui/core";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import ViewBatchesScreen from "../../sasl/common/drawer";
import ViewDigitalizedInfo from "./ViewDigitalizedInfo";
import { useGRStyles } from "../goodsReceiptStyles";

const ViewInfoIcons = ({ row, featuresAccess, qualityApprovalFlowFlag, onRefresh }) => {
  const classes = useGRStyles();
  const poQuantity = row.targetQuantity || row.poQuantity;

  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      {featuresAccess && featuresAccess.viewFGBatch && (
        <ViewBatchesScreen
          schrockenDeliveryScheduleBatchID={row.schrockenDeliveryScheduleBatchID}
          schrockenDeliveryScheduleID={row.schrockenDeliveryScheduleID}
          qualityApprovalFlowFlag={qualityApprovalFlowFlag}
          poQuantity={poQuantity}
          batchRowData={row}
          isFromGoodsReceipt
          // The drawer injects onClick onto this element, so it must be the
          // clickable node itself (not a Tooltip wrapper).
          customTrigger={
            <IconButton
              size="small"
              title="View Batch Info"
              className={classes.grIconBtn}
              aria-label="view batch info"
            >
              <VisibilityOutlinedIcon fontSize="small" />
            </IconButton>
          }
        />
      )}

      {featuresAccess && featuresAccess.viewFGConsumption && (
        <ViewDigitalizedInfo
          row={row}
          featuresAccess={featuresAccess}
          onRefresh={onRefresh}
        />
      )}
    </Box>
  );
};

export default ViewInfoIcons;
